module.exports = __webpack_public_path__ + "img/kijowski.accb495f.jpg";